import adminUserManagement from './adminUserManagement';
import clientUserManagement from './clientUserManagement/clientUserManagement';

const Mutations = Object.freeze({
	SET_SELECTED_TAB: 'userManagement/SET_SELECTED_TAB',
});

export const Actions = Object.freeze({
	LOAD_SELECTED_TAB: 'userManagement/LOAD_SELECTED_TAB',
});

export const Getters = Object.freeze({
	SELECTED_TAB: 'userManagement/CLIENTS',
});
export default {
	state: {
		selectedTab: 0,
	},
	modules: {
		adminUserManagement,
		clientUserManagement,
	},
	mutations: {
		[Mutations.SET_SELECTED_TAB](state, value) {
			state.selectedTab = value;
		},
	},
	actions: {
		[Actions.LOAD_SELECTED_TAB]({ commit }, item) {
			return new Promise(() => {
				commit(Mutations.SET_SELECTED_TAB, item);
			});
		},
	},
	getters: {
		[Getters.SELECTED_TAB]: (state) => {
			return JSON.parse(JSON.stringify(state.selectedTab));
		},
	},
};
